<div class="lesson-item">
  <div class="lesson-item__content">
    <div class="lesson-item__main">
      @if (task().thumbnailUrl) {
        <div class="lesson-item__thumbnail">
          <img 
            [src]="task().thumbnailUrl" 
            [alt]="task().title || task().name || 'Lesson thumbnail'"
            class="lesson-item__thumbnail-img"
          />
        </div>
      }
      <div class="lesson-item__main-inner">
        <div class="lesson-item__header-row">
          <div class="lesson-item__badges">
            <div class="lesson-item__badge lesson-item__badge--active">
              <div class="lesson-item__badge-text">{{ task().orderIndex }}</div>
            </div>
            <div class="lesson-item__badge lesson-item__badge--duration">
              <div class="lesson-item__badge-text">{{ formatDuration(task().estimatedTime) }}</div>
            </div>
          </div>
          @if (audioContentUrl() && !videoContentUrl()) {
            <button
              type="button"
              class="lesson-item__preview-btn"
              (click)="openContentPreview()"
            >
              <div class="lesson-item__preview-icon">
                <img src="/public/svgs/preview.svg" alt="Preview" />
              </div>
              <div class="lesson-item__preview-text">{{ 'app.components.courseCreator.publish.lessonsInformation.checkContent' | translate }}</div>
            </button>
          }
        </div>
        <div class="lesson-item__title-row" (click)="toggleExpansion()">
          <div class="lesson-item__title">{{ task().title || task().name || ('app.components.courseCreator.publish.lessonsInformation.lessonName' | translate) }}</div>
          <div class="lesson-item__chevron" [class.lesson-item__chevron--expanded]="isExpanded()">
            <img src="/public/svgs/chevron-down.svg" alt="Expand" />
          </div>
        </div>
        @if (task().description && !isExpanded()) {
          <div class="lesson-item__description">{{ task().description }}</div>
        }
        @if (isExpanded()) {
          <div class="lesson-item__expanded-content">
            <div class="lesson-item__section">
              <div class="lesson-item__section-content">{{ task().description }}</div>
            </div>
            <app-lesson-script
              [taskId]="task().id"
              [scriptUrl]="task().scriptUrl"
              [isLoading]="isScriptLoading()"
              [hasError]="hasScriptError()"
              [script]="getScript()"
            />
          </div>
        }
      </div>
    </div>
    <div class="lesson-item__footer">
      <div class="lesson-item__footer-actions">
        @if (videoContentUrl()) {
          <button
            type="button"
            class="lesson-item__generate-btn"
            (click)="openContentPreview()"
          >
            <div class="lesson-item__generate-icon">
              <img
                src="/public/svgs/preview.svg"
                alt=""
                class="lesson-item__generate-icon-preview"
              />
            </div>
            <div class="lesson-item__generate-text">
              {{ 'app.components.courseCreator.publish.lessonsInformation.checkContent' | translate }}
            </div>
          </button>
        } @else {
          <button
            type="button"
            class="lesson-item__generate-btn"
            [disabled]="isGeneratingVideo() || !task().scriptUrl"
            (click)="generateVideo()"
          >
            <div class="lesson-item__generate-icon">
              @if (isGeneratingVideo()) {
                <div class="lesson-item__generate-spinner"></div>
              } @else {
                <div class="lesson-item__generate-icon-play"></div>
              }
            </div>
            <div class="lesson-item__generate-text">
              {{
                isGeneratingVideo()
                  ? ('app.components.courseCreator.publish.lessonsInformation.generating' | translate)
                  : ('app.components.courseCreator.publish.lessonsInformation.generateVideo' | translate)
              }}
            </div>
          </button>
        }
        @if (!audioContentUrl() && showGenerateAudio()) {
          <button 
            type="button" 
            class="lesson-item__generate-btn"
            [disabled]="isGeneratingAudio() || !task().scriptUrl"
            (click)="generateAudio()"
          >
            <div class="lesson-item__generate-icon">
              @if (isGeneratingAudio()) {
                <div class="lesson-item__generate-spinner"></div>
              } @else {
                <div class="lesson-item__generate-icon-play"></div>
              }
            </div>
            <div class="lesson-item__generate-text">
              {{ isGeneratingAudio() 
                ? ('app.components.courseCreator.publish.lessonsInformation.generating' | translate)
                : ('app.components.courseCreator.publish.lessonsInformation.generateAudio' | translate)
              }}
            </div>
          </button>
        }
      </div>
    </div>
  </div>

  <app-modal
    [isOpen]="contentPreviewOpen()"
    [config]="{
      title: 'app.components.courseCreator.publish.lessonsInformation.checkContent',
      minWidth: 'min(56rem, 96vw)',
      maxWidth: '96vw',
      minHeight: 'auto',
      padding: '0 1.25rem 1.25rem',
    }"
    (closed)="onContentPreviewClosed()"
  >
    @if (contentPreview(); as media) {
      <div class="lesson-item__preview-modal-body">
        @if (media.kind === 'video') {
          <app-course-video
            [videoUrl]="media.url"
            [posterUrl]="media.poster ?? ''"
          />
        } @else {
          <audio class="lesson-item__preview-audio" controls [src]="media.url"></audio>
        }
      </div>
    }
  </app-modal>
</div>

